import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './ndoeTokens.css';
import MobileCockpitV2 from './MobileCockpitV2';
import MobileActions from './MobileActions';
import MobileClients from './MobileClients';
import CatalogExplorer from './CatalogExplorer';
import CatalogProductDetail from './CatalogProductDetail';
import WhatsAppSettings from '../whatsapp/WhatsAppSettings';
import StockCorrectionAdmin from './StockCorrectionAdmin';
import ParametresAdmin from './ParametresAdmin';

const MobileCockpit = () => {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section');

  if (section === 'clientes') return <MobileClients />;
  if (section === 'messages') return <WhatsAppSettings />;
  if (section === 'correction-stock') return <StockCorrectionAdmin />;
  if (section === 'parametres') return <ParametresAdmin />;
  if (section) return <MobileActions />;

  if (searchParams.get('catalogue') === '1') {
    const productId = searchParams.get('productId');
    const variantId = searchParams.get('variantId');
    if (productId) return <CatalogProductDetail embedded productId={productId} selectedVariantId={variantId} />;
    return <CatalogExplorer embedded />;
  }

  return <MobileCockpitV2 />;
};

export default MobileCockpit;
